import Logo from "images/logo-dark.png";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { FooterLink } from "data/types";
import React from "react";
import { globalJson } from "global/global_json";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: FooterLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "2",
    title: "Link",
    menus: [
      { href: "/about", label: "About Us" },
      { href: "/vehicles", label: "Our Fleet" },
      { href: "/contact", label: "Contact Us" },
      { href: "/privacy-policy", label: "Privacy Policy" },
      { href: "/terms-and-conditions", label: "Terms and Conditions" },
    ],
  },
  {
    id: "1",
    title: "Contact Us",
    menus: [
      {
        label: (
          <>
            {globalJson.phone1}
            <br />
            {globalJson.phone2}
          </>
        ),
        icon: (
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <mask
              id="mask0_3637_68"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="15"
              height="15"
            >
              <rect width="15" height="15" fill="url(#pattern0_3637_68)" />
            </mask>
            <g mask="url(#mask0_3637_68)">
              <rect width="16" height="16" fill="#FBBE06" />
            </g>
            <defs>
              <pattern
                id="pattern0_3637_68"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use xlinkHref="#image0_3637_68" transform="scale(0.0078125)" />
              </pattern>
              <image
                id="image0_3637_68"
                width="128"
                height="128"
                preserveAspectRatio="none"
                xlinkHref="data:image/png;base64,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"
              />
            </defs>
          </svg>
        ),
      },
      {
        label: globalJson.email,
        icon: (
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.2055 1.07711L0.531708 8.38883C0.0367857 8.6732 0.0996763 9.36227 0.591864 9.57008L3.4985 10.7896L11.3544 3.86617C11.5048 3.73219 11.718 3.93727 11.5895 4.09313L5.00241 12.1185V14.3197C5.00241 14.965 5.78171 15.2193 6.16452 14.7517L7.90085 12.638L11.3079 14.0654C11.6962 14.2295 12.1391 13.9861 12.2102 13.5677L14.179 1.75523C14.2719 1.20289 13.6786 0.803672 13.2055 1.07711Z"
              fill="#FBBE06"
            />
          </svg>
        ),
      },
      {
        label: globalJson.address.split("\n").map((line, i) => (
          <React.Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </React.Fragment>
        )),
        icon: (
          <svg
            width="12"
            height="15"
            viewBox="0 0 12 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.65039 14.0979C1.6774 8.33825 0.939941 7.74713 0.939941 5.63037C0.939941 2.73087 3.29044 0.380371 6.18994 0.380371C9.08945 0.380371 11.4399 2.73087 11.4399 5.63037C11.4399 7.74713 10.7025 8.33825 6.72949 14.0979C6.46877 14.4745 5.91109 14.4745 5.65039 14.0979ZM6.18994 7.81787C7.39807 7.81787 8.37744 6.8385 8.37744 5.63037C8.37744 4.42224 7.39807 3.44287 6.18994 3.44287C4.98181 3.44287 4.00244 4.42224 4.00244 5.63037C4.00244 6.8385 4.98181 7.81787 6.18994 7.81787Z"
              fill="#FBBE06"
            />
          </svg>
        ),
      },
    ],
  },
];

const Footer: React.FC = () => {
  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm lg:ml-16 sm:ml-0">
        <h2 className="font-bold text-white dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, index) => (
            <li key={index}>
              {item.href ? (
                <a
                  className="text-[#888888] dark:text-neutral-300 hover:text-white dark:hover:text-black flex items-center "
                  href={item.href}
                >
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </a>
              ) : (
                <span className="text-[#888888] dark:text-neutral-300 break-words flex items-center gap-2">
                  {item.icon && <span>{item.icon}</span>}
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-8 border-t border-neutral-200 dark:border-neutral-700 bg-[#111111]">
      <div className="container grid grid-cols-1 gap-y-10 gap-x-5 sm:gap-x-8  lg:grid-cols-3 lg:gap-x-10 py-12 ">
        <div className="grid grid-cols-1 gap-5 col-span-2 md:col-span-3 lg:md:col-span-1 lg:flex lg:flex-col">
          <img width={250} height={60} src={Logo} />

          <span className="text-[#888888]">
            Feel free to call us in working hours Mon - Fri. Our team will be
            happy to help answer your queries
          </span>
          {/* <div className="col-span-2 md:col-span-1">
            <Logo />
          </div> */}
          <div className="hidden lg:flex  items-center gap-3">
            {/* <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" /> */}
            <a href={globalJson.facebook}>
              <svg
                width="33"
                height="34"
                viewBox="0 0 33 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="0.379883"
                  width="33"
                  height="33"
                  rx="16.5"
                  fill="#FBBE06"
                />
                <path
                  d="M23.7656 16.8799C23.7656 12.8662 20.5137 9.61426 16.5 9.61426C12.4863 9.61426 9.23438 12.8662 9.23438 16.8799C9.23438 20.5063 11.8913 23.5121 15.3647 24.0576V18.9802H13.519V16.8799H15.3647V15.2791C15.3647 13.4583 16.4487 12.4525 18.109 12.4525C18.9041 12.4525 19.7355 12.5943 19.7355 12.5943V14.3814H18.8191C17.9168 14.3814 17.6353 14.9416 17.6353 15.5161V16.8799H19.6503L19.328 18.9802H17.6353V24.0576C21.1087 23.5121 23.7656 20.5063 23.7656 16.8799Z"
                  fill="#111111"
                />
              </svg>
            </a>
            <a href={globalJson.instagram}>
              <svg
                width="33"
                height="34"
                viewBox="0 0 33 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  y="0.379883"
                  width="33"
                  height="33"
                  rx="16.5"
                  fill="#FBBE06"
                />
                <path
                  d="M16.5029 13.511C14.6396 13.511 13.1367 15.0139 13.1367 16.8772C13.1367 18.7405 14.6396 20.2434 16.5029 20.2434C18.3662 20.2434 19.8691 18.7405 19.8691 16.8772C19.8691 15.0139 18.3662 13.511 16.5029 13.511ZM16.5029 19.0657C15.2988 19.0657 14.3145 18.0842 14.3145 16.8772C14.3145 15.6702 15.2959 14.6887 16.5029 14.6887C17.71 14.6887 18.6914 15.6702 18.6914 16.8772C18.6914 18.0842 17.707 19.0657 16.5029 19.0657ZM20.792 13.3733C20.792 13.8098 20.4404 14.1584 20.0068 14.1584C19.5703 14.1584 19.2217 13.8069 19.2217 13.3733C19.2217 12.9397 19.5732 12.5881 20.0068 12.5881C20.4404 12.5881 20.792 12.9397 20.792 13.3733ZM23.0215 14.1702C22.9717 13.1184 22.7314 12.1868 21.9609 11.4192C21.1934 10.6516 20.2617 10.4114 19.21 10.3586C18.126 10.2971 14.877 10.2971 13.793 10.3586C12.7441 10.4084 11.8125 10.6487 11.042 11.4163C10.2715 12.1838 10.0342 13.1155 9.98145 14.1672C9.91992 15.2512 9.91992 18.5002 9.98145 19.5842C10.0312 20.636 10.2715 21.5676 11.042 22.3352C11.8125 23.1028 12.7412 23.343 13.793 23.3958C14.877 23.4573 18.126 23.4573 19.21 23.3958C20.2617 23.3459 21.1934 23.1057 21.9609 22.3352C22.7285 21.5676 22.9688 20.636 23.0215 19.5842C23.083 18.5002 23.083 15.2542 23.0215 14.1702ZM21.6211 20.7473C21.3926 21.3215 20.9502 21.7639 20.373 21.9954C19.5088 22.3381 17.458 22.259 16.5029 22.259C15.5479 22.259 13.4941 22.3352 12.6328 21.9954C12.0586 21.7668 11.6162 21.3245 11.3848 20.7473C11.042 19.8831 11.1211 17.8323 11.1211 16.8772C11.1211 15.9221 11.0449 13.8684 11.3848 13.0071C11.6133 12.4329 12.0557 11.9905 12.6328 11.759C13.4971 11.4163 15.5479 11.4954 16.5029 11.4954C17.458 11.4954 19.5117 11.4192 20.373 11.759C20.9473 11.9875 21.3896 12.4299 21.6211 13.0071C21.9639 13.8713 21.8848 15.9221 21.8848 16.8772C21.8848 17.8323 21.9639 19.886 21.6211 20.7473Z"
                  fill="#111111"
                />
              </svg>
            </a>
            <a href={globalJson.instagram}>
              <svg
                width="33"
                height="34"
                viewBox="0 0 33 34"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <rect
                  y="0.379883"
                  width="33"
                  height="33"
                  rx="16.5"
                  fill="#FBBE06"
                />
                <rect
                  x="9"
                  y="9"
                  width="15"
                  height="15"
                  fill="url(#pattern0_3637_76)"
                />
                <defs>
                  <pattern
                    id="pattern0_3637_76"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1"
                  >
                    <use
                      xlinkHref="#image0_3637_76"
                      transform="scale(0.0078125)"
                    />
                  </pattern>
                  <image
                    id="image0_3637_76"
                    width="128"
                    height="128"
                    preserveAspectRatio="none"
                    xlinkHref="data:image/png;base64,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"
                  />
                </defs>
              </svg>
            </a>
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
        {/* <SocialsList1 className="lg:hidden flex items-start space-x-3 lg:flex-col lg:space-y-2.5 lg:items-start" /> */}
      </div>
    </div>
  );
};

export default Footer;
